import BaseAPI from '@/apis/base/baseApi';

export default class IntegrationAPI extends BaseAPI {
  apiName = 'ITG';
}
